module.exports = __webpack_public_path__ + "static/img/banner-1.1b545ea.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/banners/banner-1.jpg
// module id = TsUD
// module chunks = 1